module.exports = __webpack_public_path__ + "static/media/buckwheat.f8e68b43.jpg";